import {
  LicenseInfo as MuiLicenseInfo,
  muiXTelemetrySettings,
} from "@mui/x-license";
import {
  Alert,
  Body,
  DevelopmentInfo,
  Footer,
  Header,
  useAlerts,
  useUsers,
} from "common";
import { MainContainer } from "common/components/Main-Container/MainContainer";
import ReactGA from "react-ga4";
import { useTranslation } from "react-i18next";

MuiLicenseInfo.setLicenseKey(window.RUNTIME_CONFIG.muiLicenseKey);
muiXTelemetrySettings.disableTelemetry();

export const App = () => {
  const { alert } = useAlerts();
  const { t } = useTranslation();
  const { loggedInUser, currentUser, accessDenied } = useUsers();

  if (
    currentUser.isLoaded &&
    !accessDenied &&
    window.RUNTIME_CONFIG.gaMeasurementId
  ) {
    ReactGA.initialize(window.RUNTIME_CONFIG.gaMeasurementId);
  }

  return (
    <>
      <DevelopmentInfo />
      <Header
        logoTitle={t("app.logoTitle")}
        logoSubtitle={t("app.logoSubtitle")}
        userDisplayName={loggedInUser.displayName}
      />
      <Body>
        {currentUser.isLoaded ? (
          <>
            {/* APP SPECIFIC: Faculty Leave UI does not use Navbar. */}
            {alert.exists && <Alert />}
            <MainContainer idAttr="faculty-leave-main" />
          </>
        ) : (
          <>{alert.exists && <Alert />}</>
        )}
      </Body>
      <Footer
        copyrightYear={t("app.copyrightYear")}
        productVersion={window.RUNTIME_CONFIG.productVersion || __APP_VERSION__}
      />
    </>
  );
};
